import React from 'react';

import { Switch } from 'antd';

import styled from 'styled-components';

import { showDate } from '@libs/NwMoment';

import { useLayoutContext } from '@contexts/LayoutContext';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import { NwLinkButton } from '@components/Gui/NwButton';
import NwDividerVertical from '@components/Gui/NwDividerVertical';

const SelectIdsContainer = styled.div`
    .date-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding-bottom: 1.5rem;

        .date-text {
            font-weight: 700;
        }
        .date-actions {
        }
    }

    ul.event-models {
        list-style: none;
        padding-left: 0px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 1rem;
        width: 100%;

        @media (max-width: 720px) {
            flex-direction: column;
        }

        > li {
            align-items: center;
            width: calc((100% - 2rem) / 2);

            @media (max-width: 768px) {
                width: 100%;
            }

            .li-content {
                display: flex;
            }
            .event-model-name {
                margin-left: 20px;
            }
        }
        border-bottom: ${(props) => props.theme.DefaultBorder};
        padding-bottom: 20px;
    }
`;

const Container = styled.div`
    padding-top: 20px;
`;

const SelectModelsIds = ({ form, eventDates, onlyOneDay, modelProperty, onChange }) => {
    const layoutContext = useLayoutContext();
    const { isMobile } = layoutContext;

    const onToggleSelectedModel = (modelId) => {
        if (form.values.modelIds.includes(modelId)) {
            const models = form.values.modelIds.filter((id) => id !== modelId);
            form.setFieldValue('modelIds', [...models]);
            if (onChange) {
                onChange(models);
            }
            return;
        }
        const models = [...form.values.modelIds, modelId];
        form.setFieldValue('modelIds', models);
        if (onChange) {
            onChange(models);
        }
    };

    const checkModelSelected = (modelId) => {
        if (form.values.modelIds.find((id) => id === modelId)) {
            return true;
        }
        return false;
    };

    eventDates.sort((date1, date2) => (date1.FromDate > date2.FromDate ? 1 : -1));

    if (onlyOneDay && eventDates[0] && eventDates[0].EventDatesModels && eventDates[0].EventDatesModels.length === 0) {
        return null;
    }

    const onSelectAllModels = (eventDate) => {
        const models = form && form.values && form.values.modelIds ? [...form.values.modelIds] : [];
        for (const model of eventDate.EventDatesModels) {
            if (!models.includes(model.ID)) {
                models.push(model.ID);
            }
        }
        form.setFieldValue('modelIds', models);
        if (onChange) {
            onChange(models);
        }
    };

    const onDeselectAllModels = (eventDate) => {
        let models = form && form.values && form.values.modelIds ? [...form.values.modelIds] : [];
        for (const model of eventDate.EventDatesModels) {
            //remove ID from form values
            if (models.includes(model.ID)) {
                models = models.filter((id) => id !== model.ID);
            }
        }
        form.setFieldValue('modelIds', models);
        if (onChange) {
            onChange(models);
        }
    };

    return (
        <Container>
            {eventDates.map((eventDate) => (
                <SelectIdsContainer key={eventDate.ID}>
                    <div className="date-container">
                        {!onlyOneDay && (
                            <div className="date-text">
                                {showDate(eventDate.FromDate, isMobile ? 'ext-short' : 'ext-notime')}
                            </div>
                        )}
                        <div className="date-actions">
                            <NwLinkButton label="select all" onClick={() => onSelectAllModels(eventDate)} />
                            <NwDividerVertical />
                            <NwLinkButton label="deselect all" onClick={() => onDeselectAllModels(eventDate)} />
                        </div>
                    </div>
                    <ul className="event-models">
                        {eventDate.EventDatesModels.map((eventModel) => (
                            <li key={eventModel.ID} className="event-model">
                                <div className="li-content">
                                    <Switch
                                        checked={checkModelSelected(eventModel[modelProperty])}
                                        onChange={() => onToggleSelectedModel(eventModel[modelProperty])}
                                    />
                                    <div
                                        className="event-model-name"
                                        onClick={() => onToggleSelectedModel(eventModel[modelProperty])}
                                    >
                                        {getContactName(eventModel.ModelID)}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </SelectIdsContainer>
            ))}
        </Container>
    );
};

export default SelectModelsIds;
